export default __webpack_public_path__ + "static/media/seeds_of_hope.f0238396.png";